// FICHIER : frontend/src/pages/Entreprise.jsx

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BRAND } from '../constants/brand';
import NavLogo from '../components/NavLogo';
import axios from 'axios';

const API = 'https://ark-recruitment-backend.onrender.com/api';

// ── Icône flèche ──
const IconArrow = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h14M12 5l7 7-7 7"/>
  </svg>
);

// ── Icône œil (afficher/masquer mot de passe) ──
const IconEye = ({ open }) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    {open
      ? <><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></>
      : <><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></>
    }
  </svg>
);

// ── Composant principal ──
export default function Entreprise() {
  const navigate = useNavigate();

  const [onglet, setOnglet] = useState('inscription');

  // ── États formulaire ──
  const [nom,      setNom]      = useState('');
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [showPwd,  setShowPwd]  = useState(false);
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState('');

  // ── Inscription réelle via API ──
  const handleInscription = async () => {
    setError('');
    if (!nom.trim() || !email.trim() || !password.trim()) {
      setError('Veuillez remplir tous les champs.');
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/signup`, { nom: nom.trim(), email: email.trim(), password });
      localStorage.setItem('company_id', res.data.company_id);
      localStorage.setItem('company_nom', res.data.nom);
      localStorage.setItem('company_email', res.data.email);
      navigate('/marque');
    } catch (e) {
      const msg = e.response?.data?.detail || "Erreur lors de la création du compte.";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  // ── Connexion réelle via API ──
  const handleConnexion = async () => {
    setError('');
    if (!email.trim() || !password.trim()) {
      setError('Email et mot de passe obligatoires.');
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, { email: email.trim(), password });
      localStorage.setItem('company_id', res.data.company_id);
      localStorage.setItem('company_nom', res.data.nom);
      localStorage.setItem('company_email', res.data.email);
      navigate('/dashboard');
    } catch (e) {
      const msg = e.response?.data?.detail || "Email ou mot de passe incorrect.";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') onglet === 'inscription' ? handleInscription() : handleConnexion();
  };

  // ── Style onglet ──
  const tabStyle = (key) => ({
    flex: 1,
    padding: '13px 0',
    fontSize: 14,
    fontWeight: 600,
    fontFamily: 'DM Sans,sans-serif',
    background: 'none',
    border: 'none',
    borderBottom: `2px solid ${onglet === key ? 'var(--accent)' : 'transparent'}`,
    color: onglet === key ? 'var(--text)' : 'var(--muted)',
    cursor: 'pointer',
    transition: 'color 0.2s, border-color 0.2s',
  });

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', color: 'var(--text)', fontFamily: 'DM Sans,sans-serif', display: 'flex', flexDirection: 'column' }}>

      {/* ── NAVIGATION ── */}
      <nav style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 32px', height: 64, borderBottom: '1px solid var(--border)', background: 'var(--nav-bg)' }}>
        <button onClick={() => navigate('/')} style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}>
          <NavLogo/>
        </button>
        <span onClick={() => navigate('/')} style={{ color: 'var(--muted)', fontSize: 13, fontWeight: 500, cursor: 'pointer' }}>
          ← Retour à l'accueil
        </span>
      </nav>

      {/* ── CONTENU PRINCIPAL ── */}
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px 20px', position: 'relative', overflow: 'hidden' }}>

        {/* Lueur de fond */}
        <div style={{ position: 'absolute', top: '15%', left: '50%', transform: 'translateX(-50%)', width: 700, height: 500, pointerEvents: 'none', background: 'radial-gradient(ellipse, var(--hero-glow) 0%, transparent 68%)' }}/>

        {/* ── Carte principale ── */}
        <div style={{ position: 'relative', zIndex: 1, width: '100%', maxWidth: 460, background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 18, overflow: 'hidden' }}>

          {/* ── En-tête ── */}
          <div style={{ padding: '32px 36px 0', textAlign: 'center' }}>

            {/* Badge */}
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, border: '1px solid var(--border)', background: 'var(--hero-badge)', padding: '5px 14px', borderRadius: 100, marginBottom: 18, fontSize: 11, color: 'var(--accent2)', fontWeight: 500 }}>
              <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'var(--accent2)', display: 'inline-block' }}/>
              Espace entreprise
            </div>

            <h1 style={{ fontFamily: 'Syne,sans-serif', fontSize: 22, fontWeight: 800, letterSpacing: '-0.6px', margin: '0 0 6px' }}>
              Construisez votre marque employeur
            </h1>
            <p style={{ color: 'var(--muted)', fontSize: 13, lineHeight: 1.6, margin: '0 0 24px' }}>
              En quelques minutes, avec l'intelligence artificielle
            </p>

            {/* ── Onglets ── */}
            <div style={{ display: 'flex', borderBottom: '1px solid var(--border)' }}>
              <button style={tabStyle('connexion')} onClick={() => { setOnglet('connexion'); setError(''); }}>
                Connexion
              </button>
              <button style={tabStyle('inscription')} onClick={() => { setOnglet('inscription'); setError(''); }}>
                Créer un compte
              </button>
            </div>
          </div>

          {/* ── Corps formulaire ── */}
          <div style={{ padding: '28px 36px 36px' }}>

            {/* ── FORMULAIRE INSCRIPTION ── */}
            {onglet === 'inscription' && (
              <>
                <div style={{ marginBottom: 16 }}>
                  <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--muted)', marginBottom: 8, textTransform: 'uppercase', letterSpacing: 0.3 }}>
                    Nom de votre entreprise
                  </label>
                  <input type="text" value={nom} onChange={e => setNom(e.target.value)} onKeyDown={handleKeyDown} placeholder="Ex : Ark Intelligence" style={{ width: '100%', boxSizing: 'border-box', background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 10, padding: '12px 16px', fontSize: 14, color: 'var(--text)', outline: 'none', fontFamily: 'DM Sans,sans-serif' }}/>
                </div>
                <div style={{ marginBottom: 16 }}>
                  <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--muted)', marginBottom: 8, textTransform: 'uppercase', letterSpacing: 0.3 }}>Adresse e-mail</label>
                  <input type="email" value={email} onChange={e => setEmail(e.target.value)} onKeyDown={handleKeyDown} placeholder="vous@entreprise.com" style={{ width: '100%', boxSizing: 'border-box', background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 10, padding: '12px 16px', fontSize: 14, color: 'var(--text)', outline: 'none', fontFamily: 'DM Sans,sans-serif' }}/>
                </div>
                <div style={{ marginBottom: 20 }}>
                  <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--muted)', marginBottom: 8, textTransform: 'uppercase', letterSpacing: 0.3 }}>Mot de passe</label>
                  <div style={{ position: 'relative' }}>
                    <input type={showPwd ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} onKeyDown={handleKeyDown} placeholder="••••••••" style={{ width: '100%', boxSizing: 'border-box', background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 10, padding: '12px 44px 12px 16px', fontSize: 14, color: 'var(--text)', outline: 'none', fontFamily: 'DM Sans,sans-serif' }}/>
                    <button onClick={() => setShowPwd(v => !v)} style={{ position: 'absolute', right: 14, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--muted)', padding: 0, display: 'flex', alignItems: 'center' }}><IconEye open={showPwd}/></button>
                  </div>
                </div>
                {error && (<div style={{ background: 'rgba(220,38,38,0.04)', border: '1px solid rgba(220,38,38,0.12)', borderRadius: 8, padding: '10px 14px', fontSize: 13, color: 'var(--error)', marginBottom: 16 }}>{error}</div>)}
                <button onClick={handleInscription} disabled={loading} style={{ width: '100%', background: loading ? 'var(--border)' : 'var(--accent)', color: '#fff', border: 'none', borderRadius: 10, padding: '13px 20px', fontSize: 15, fontWeight: 600, fontFamily: 'DM Sans,sans-serif', cursor: loading ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginTop: 4 }}>
                  {loading ? 'Création en cours…' : (<>Créer ma marque employeur <IconArrow/></>)}
                </button>
                <p style={{ textAlign: 'center', fontSize: 12, color: 'var(--muted)', margin: '16px 0 0', lineHeight: 1.6 }}>
                  En créant un compte, vous acceptez nos <span style={{ color: 'var(--accent2)', cursor: 'pointer' }}>conditions d'utilisation</span>
                </p>
              </>
            )}

            {/* ── FORMULAIRE CONNEXION ── */}
            {onglet === 'connexion' && (
              <>
                <div style={{ marginBottom: 16 }}>
                  <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--muted)', marginBottom: 8, textTransform: 'uppercase', letterSpacing: 0.3 }}>Adresse e-mail</label>
                  <input type="email" value={email} onChange={e => setEmail(e.target.value)} onKeyDown={handleKeyDown} placeholder="vous@entreprise.com" style={{ width: '100%', boxSizing: 'border-box', background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 10, padding: '12px 16px', fontSize: 14, color: 'var(--text)', outline: 'none', fontFamily: 'DM Sans,sans-serif' }}/>
                </div>
                <div style={{ marginBottom: 20 }}>
                  <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--muted)', marginBottom: 8, textTransform: 'uppercase', letterSpacing: 0.3 }}>Mot de passe</label>
                  <div style={{ position: 'relative' }}>
                    <input type={showPwd ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} onKeyDown={handleKeyDown} placeholder="••••••••" style={{ width: '100%', boxSizing: 'border-box', background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 10, padding: '12px 44px 12px 16px', fontSize: 14, color: 'var(--text)', outline: 'none', fontFamily: 'DM Sans,sans-serif' }}/>
                    <button onClick={() => setShowPwd(v => !v)} style={{ position: 'absolute', right: 14, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--muted)', padding: 0, display: 'flex', alignItems: 'center' }}><IconEye open={showPwd}/></button>
                  </div>
                </div>
                {error && (<div style={{ background: 'rgba(220,38,38,0.04)', border: '1px solid rgba(220,38,38,0.12)', borderRadius: 8, padding: '10px 14px', fontSize: 13, color: 'var(--error)', marginBottom: 16 }}>{error}</div>)}
                <button onClick={handleConnexion} disabled={loading} style={{ width: '100%', background: loading ? 'var(--border)' : 'var(--accent)', color: '#fff', border: 'none', borderRadius: 10, padding: '13px 20px', fontSize: 15, fontWeight: 600, fontFamily: 'DM Sans,sans-serif', cursor: loading ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginTop: 4 }}>
                  {loading ? 'Connexion en cours…' : (<>Se connecter <IconArrow/></>)}
                </button>
              </>
            )}
          </div>
        </div>
      </div>

      {/* ── FOOTER minimal ── */}
      <footer style={{ borderTop: '1px solid var(--border)', padding: '18px 32px', textAlign: 'center', color: 'var(--muted)', fontSize: 12 }}>
        © {BRAND.year} {BRAND.name} — Tous droits réservés
      </footer>

    </div>
  );
}